// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1c438578","796":"0b1bac2f"}[chunkId] + ".chunk.js";
};